import { HistoryOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import React, {
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from '@/infrastructure/logger';
import { getPlatform } from '@/infrastructure/product-info';
import {
  storageGet,
  storageSet,
} from '@/infrastructure/storage-utils';
import { Loading } from '@/presentation/components/loading';
import { ToolsButton } from '@/presentation/layouts/tools/button';
import { useStores } from '@/presentation/store';
import { IRightlyNotice } from '@/presentation/store/rightly';
import style from './index.module.scss';

export const RightlyNotice = observer(() => {
  const [hover, setHover] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [notice, setNotice] = useState<IRightlyNotice>({ version: 0, platform: '', content: [] });
  const { pathname } = useLocation();
  const { notices, loaded: rightlyLoaded } = useStores().RightlyStore;
  const { productId, loaded: productLoaded } = useStores().ProductStore;

  const showNotice = (showAll: boolean) => {
    setVisible(true);
    setShowAll(showAll);
  };

  useEffect(() => {
    if (!pathname.startsWith('/compliance') || !rightlyLoaded || !productLoaded) {
      return;
    }
    const notice = notices.find(item => item.platform === getPlatform()) || { version: 0, platform: '', content: [] };
    setNotice(notice);
    const readVersion = getReadVersion();
    if (readVersion < notice.version && !visible) {
      showNotice(false);
    }
    setReadVersion(notice.version);
  }, [rightlyLoaded, productLoaded, notices, pathname]);

  const renderContent = () => {
    if (!rightlyLoaded || !productLoaded || !notice || !visible) {
      return <div className={style.content}>
        <Loading marginTop={'0'}/>
      </div>;
    }
    let content;
    if (!notice.content || notice.content.length === 0) {
      content = '<div>暂无更新日志</div>';
    } else if (showAll || notice.content.length <= 1) {
      content = `<div>${notice.content.join('<br>')}</div>`;
    } else {
      const showScript = '<script>function showMore() {document.getElementById(\'more-btn\').style.display = \'none\';document.getElementById(\'more-content\').style.display = \'block\';}</script>';
      const showMore = '<a id=\'more-btn\' onclick=\'showMore()\' style=\'cursor:pointer;color:rgb(0, 98, 255);padding:8px\'>查看更多</a>';
      const moreContent = `<div id='more-content' style='display: none'>${notice.content.filter((_, index) => index !== 0).join('<br>')}</div>`;
      content = `<div>${notice.content[0]}<br>${showMore}${showScript}${moreContent}</div>`;
    }
    return <iframe
      className={style.content}
      src={`data:text/html;charset=utf-8,${content}`}
    />;
  };

  const getReadVersion = (): number => {
    try {
      const versionStr = storageGet(`rightly-notice-${getPlatform()}`);
      if (versionStr) {
        return Number.parseInt(versionStr, 10);
      }
      return 0;
    } catch (e) {
      logger.info('RightlyNotice|get storage error:', e);
      return 0;
    }
  };

  const setReadVersion = (version: number) => {
    try {
      storageSet(`rightly-notice-${getPlatform()}`, version);
    } catch (e) {
      logger.info('RightlyNotice|set storage error:', e);
    }
  };

  if (!pathname.startsWith('/compliance') || !productId) {
    return null;
  }

  return <>
    <div
      className={style.rightlyNotice}
      onClick={() => showNotice(true)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <ToolsButton style={{ width: hover ? '100%' : '40px' }}>
        <HistoryOutlined style={{ fontSize: '20px' }}/>
        <div className={style.textLayout} style={{ display: hover ? 'flex' : 'none' }}>
          <div className={style.text}>{'Rightly SDK'}</div>
          <div className={style.subText}>{'发布日志'}</div>
        </div>
      </ToolsButton>
    </div>
    <Modal
      title={'Rightly SDK 发布日志'}
      width={800}
      visible={visible}
      closable={true}
      centered
      footer={null}
      onCancel={() => setVisible(false)}
    >
      {renderContent()}
    </Modal>
  </>;
});
